/* tslint:disable */
/* eslint-disable */
/**
 * Authentication Service Api
 * Authentication Service Api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmployeeStatus
 */
export interface EmployeeStatus {
    /**
     * 
     * @type {number}
     * @memberof EmployeeStatus
     */
    employee: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeStatus
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeStatus
     */
    lastName: string;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeStatus
     */
    isInPause: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeStatus
     */
    active: boolean;
    /**
     * 
     * @type {number}
     * @memberof EmployeeStatus
     */
    currentWorkTime: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeStatus
     */
    pauseTime: number;
}

/**
 * Check if a given object implements the EmployeeStatus interface.
 */
export function instanceOfEmployeeStatus(value: object): value is EmployeeStatus {
    if (!('employee' in value) || value['employee'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('isInPause' in value) || value['isInPause'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('currentWorkTime' in value) || value['currentWorkTime'] === undefined) return false;
    if (!('pauseTime' in value) || value['pauseTime'] === undefined) return false;
    return true;
}

export function EmployeeStatusFromJSON(json: any): EmployeeStatus {
    return EmployeeStatusFromJSONTyped(json, false);
}

export function EmployeeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'employee': json['employee'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'isInPause': json['isInPause'],
        'active': json['active'],
        'currentWorkTime': json['currentWorkTime'],
        'pauseTime': json['pauseTime'],
    };
}

  export function EmployeeStatusToJSON(json: any): EmployeeStatus {
      return EmployeeStatusToJSONTyped(json, false);
  }

  export function EmployeeStatusToJSONTyped(value?: EmployeeStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee': value['employee'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'isInPause': value['isInPause'],
        'active': value['active'],
        'currentWorkTime': value['currentWorkTime'],
        'pauseTime': value['pauseTime'],
    };
}

